'use strict';

const ReactDOM = require('react-dom');
const routes = require('./routes');

ReactDOM.render(routes, document.getElementById('app'));



// WEBPACK FOOTER //
// ./app/index.js